import { jwtDecode } from 'jwt-decode';

import { User } from '../types/user';

const PERSIST_KEY = 'persist:root-backoffice';

export const clearStoredUser = (): void => {
  try {
    const persist = localStorage.getItem(PERSIST_KEY);
    if (!persist) {
      return;
    }

    const parsedPersist = JSON.parse(persist) as unknown as Record<string, string>;
    const nextPersist = { ...parsedPersist, user: JSON.stringify(null) };
    localStorage.setItem(PERSIST_KEY, JSON.stringify(nextPersist));
  } catch {
    localStorage.removeItem(PERSIST_KEY);
  }
};

export const checkIfTokenIsValid = (user: Pick<User, 'accessToken'> | null): boolean => {
  try {
    if (!user?.accessToken) return false;
    const decoded: { exp: number } = jwtDecode(user.accessToken);
    return decoded.exp >= Date.now() / 1000;
  } catch {
    return false;
  }
};
